import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUserIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	"data-name": "Component 5 \\u2013 1",
	viewBox: "0 0 39.794 38.3",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "m19.896 0c-10.981 0-19.896 8.5718-19.896 19.15 5.8184e-7 10.579 8.9158 19.15 19.896 19.15 10.981 1e-6 19.898-8.5718 19.898-19.15 0-10.579-8.9177-19.15-19.898-19.15zm0 0.5c10.721-5.2e-7 19.398 8.3527 19.398 18.65-1e-6 10.298-8.6777 18.65-19.398 18.65-10.721 0-19.396-8.3527-19.396-18.65 0-10.298 8.6757-18.65 19.396-18.65z",
		color: "#000000",
		colorRendering: "auto",
		dominantBaseline: "auto",
		imageRendering: "auto",
		shapeRendering: "auto",
		"solid-color": "#000000"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M4.245,30.576c.6-1.763,2.36-3.065,5.436-4.189a30.522,30.522,0,0,1,10.743-2.268,24.441,24.441,0,0,1,10.742,2.268,10.508,10.508,0,0,1,4.948,3.434A19.852,19.852,0,0,1,19.9,38.05,19.888,19.888,0,0,1,4.245,30.576Zm10.808-11.31a6.649,6.649,0,0,1-2.089-5.1,6.649,6.649,0,0,1,2.089-5.1,7.651,7.651,0,0,1,5.371-2.268A6.632,6.632,0,0,1,25.8,9.061a6.649,6.649,0,0,1,2.089,5.1,7.928,7.928,0,0,1-2.089,5.1,7.4,7.4,0,0,1-5.371,1.985A7.4,7.4,0,0,1,15.053,19.266Z",
		"data-name": "Intersection 2"
	})]
});
export default SvgUserIcon;
